var app = angular.module("leonardo");

var DeleteDialog = function($scope, FormErrorsService) {
  $scope.object = $scope.ngDialogData.object;
  $scope.alert_message = $scope.ngDialogData.alert_message;
  $scope.type = $scope.ngDialogData.type;
  $scope.title = $scope.ngDialogData.title ? $scope.ngDialogData.title : 'Delete ' + $scope.type;
  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    $scope.object.remove().then(function() {
      $scope.confirm($scope.object);
    });
  };
};

app.controller('DeleteDialog', ['$scope', 'FormErrorsService', DeleteDialog]);
